import * as RadixTabs from "@radix-ui/react-tabs";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export const Tabs = RadixTabs.Root;

export function TabsList({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <RadixTabs.List
      className={cn(
        "flex items-center gap-1 border-b border-[var(--color-border-subtle)] -mb-px overflow-x-auto",
        className,
      )}
    >
      {children}
    </RadixTabs.List>
  );
}

export function TabsTrigger({
  value,
  children,
  disabled,
  hint,
}: {
  value: string;
  children: ReactNode;
  disabled?: boolean;
  hint?: string;
}) {
  return (
    <RadixTabs.Trigger
      value={value}
      disabled={disabled}
      title={hint}
      className={cn(
        "relative px-3 py-2 text-[13px] font-medium tracking-[-0.165px] whitespace-nowrap transition-colors",
        "text-[var(--color-fg-subtle)] hover:text-[var(--color-fg)]",
        "data-[state=active]:text-[var(--color-fg)]",
        "after:absolute after:left-0 after:right-0 after:-bottom-px after:h-px after:bg-transparent",
        "data-[state=active]:after:bg-[var(--color-accent)]",
        "disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:text-[var(--color-fg-subtle)]",
        "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[var(--color-accent)] rounded-t",
      )}
    >
      {children}
    </RadixTabs.Trigger>
  );
}

export function TabsContent({
  value,
  children,
  className,
}: {
  value: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <RadixTabs.Content value={value} className={cn("pt-5 focus-visible:outline-none", className)}>
      {children}
    </RadixTabs.Content>
  );
}
